module.exports = __webpack_public_path__ + "static/img/4.bc3a2df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hw/4.jpg
// module id = dRr0
// module chunks = 0